import React, { useState, useEffect, useRef } from 'react';
import { Box, Paper, Typography, TextField, Button, InputAdornment, IconButton, Alert } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ADMIN_EMAIL = 'admin@admin';
const ADMIN_PASSWORD = 'admin'; // À remplacer par une vraie logique sécurisée

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Images du carrousel (mêmes que Home)
    const backgroundImages = [
        'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=1920&h=1080&fit=crop',
        'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1920&h=1080&fit=crop',
        'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=1920&h=1080&fit=crop',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&h=1080&fit=crop',
        'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=1920&h=1080&fit=crop',
        'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=1920&h=1080&fit=crop',
    ];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const intervalRef = useRef();
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setCurrentImageIndex((prev) => (prev === backgroundImages.length - 1 ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(intervalRef.current);
    }, [backgroundImages.length]);

    useEffect(() => {
        document.body.style.margin = '0';
        document.body.style.background = 'black';
        return () => {
            document.body.style.background = '';
        };
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
            // Simule une connexion admin
            localStorage.setItem('isAdmin', 'true');
            navigate('/admin-panel');
        } else {
            setError('Invalid credentials.');
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            {/* Carrousel d'images de fond */}
            {backgroundImages.map((img, idx) => (
                <Box
                    key={idx}
                    component="img"
                    src={img}
                    alt="bg"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: idx === currentImageIndex ? 1 : 0,
                        transition: 'opacity 1.5s ease-in-out',
                        zIndex: 0,
                        filter: 'blur(6px) brightness(0.5)',
                    }}
                />
            ))}
            {/* Overlay foncé pour lisibilité */}
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.6) 100%)',
                zIndex: 1,
            }} />
            <Paper elevation={6} sx={{ p: 5, borderRadius: 4, minWidth: 340, maxWidth: 380, width: '100%', background: 'rgba(255,255,255,0.98)', boxShadow: '0 8px 32px rgba(255,107,107,0.10)', zIndex: 2 }}>
                <Button startIcon={<ArrowBackIcon />} sx={{ mb: 2 }} onClick={() => navigate('/')} color="inherit" variant="text">
                    Back
                </Button>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <LoginIcon sx={{ fontSize: 48, color: '#FF6B6B', mb: 1 }} />
                    <Typography variant="h5" fontWeight={700} gutterBottom>Admin Login</Typography>
                    <Typography variant="body2" color="text.secondary">Reserved for administration</Typography>
                </Box>
                <form onSubmit={handleLogin}>
                    <TextField
                        label="Email"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        fullWidth
                        required
                        sx={{ mb: 3, background: 'white', borderRadius: 2 }}
                    />
                    <TextField
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        fullWidth
                        required
                        sx={{ mb: 2, background: 'white', borderRadius: 2 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(v => !v)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{
                            background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)',
                            color: 'white',
                            fontWeight: 700,
                            borderRadius: 3,
                            py: 1.5,
                            mt: 1,
                            boxShadow: '0 4px 16px rgba(255,107,107,0.10)',
                            textTransform: 'none',
                            fontSize: '1.1rem',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #E53E3E 0%, #FF6B6B 100%)',
                            },
                        }}
                        startIcon={<LoginIcon />}
                    >
                        Login
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default Login; 